import { useEffect, useState } from 'react'
import Card from '../components/Card'
import CardGrid from '../components/CardGrid'
import Hero from '../components/Hero'
import { API_URL } from '../../constants'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ErrorOverlay, LoadingOverlay } from '../../shared/components/Loading'

export default function News() {
    const [news, setNews] = useState([])
    const [loading, setLoading] = useState(true)
    const navigate = useNavigate()
    const { t } = useTranslation()
    const [error, setError] = useState(null)

    useEffect(() => {
        const fetchNews = async () => {
            try {
                const response = await fetch(`${API_URL}/get-list-news`, {
                    headers: {
                        'Accept-Language': 'en',
                    },
                })
                const json = await response.json()
                if (json.success && Array.isArray(json.data)) {
                    setNews(json.data)
                } else {
                    console.error('Invalid data structure:', json)
                    setError(`Invalid data structure: ${json}`)
                }
            } catch (error) {
                console.error('Failed to fetch news:', error)
                setError(`Failed to fetch news: ${error}`)
            } finally {
                setLoading(false)
            }
        }

        fetchNews()
    }, [])

    const renderCard = item =>
        item.is_active === 1 || item.is_active === '1' ? (
            <Card
                key={item.id}
                label={item.title}
                description={item.subtitle}
                imageSrc={item.header_image}
                buttonLabel={item.call_to_action}
                onButtonClick={() => navigate(`/news/${item.id}`)}
            >
                <p>{item.urgency_message}</p>
            </Card>
        ) : null

    return (
        <div>
            <Hero
                title={t('news.title')}
                imageUrl='https://images.unsplash.com/photo-1627967448399-12de1922ae67?q=80&w=1170&auto=format&fit=crop'
                size='medium'
            />
            <div className='mx-auto my-8 max-w-7xl'>
                {loading ? (
                    <LoadingOverlay message={t('loading')} />
                ) : (
                    // <p className='text-center text-gray-500'>{t('loading')}</p>
                    <div>
                        {error && <ErrorOverlay message={error} onClose={() => setError(null)} />}
                        <CardGrid data={news} renderCard={renderCard} />
                    </div>
                )}
            </div>
        </div>
    )
}
